import React from "react";
import { ShieldCheckIcon } from "@heroicons/react/solid";
import { ButtonBase } from "@reusejs/react";
import { useRouter } from "next/router";

export default function DocumentPreview(props: any) {
  const router = useRouter();

  return (
    <div className="w-full mt-8 border-t pt-8">
      <div className="w-full flex justify-between items-center">
        <div>
          <label className="block text-sm font-medium text-gray-800 capitalize">
            <span className="font-bold"> Other Verified Document: </span>
            {props.kycData?.other_document_data?.document_type}
          </label>
        </div>
        {process.env.NEXT_PUBLIC_APP_NAME === "banker" && (
          <div className="flex">
            <div className="sm:mr-4">
              <ButtonBase
                variant="primary"
                type="button"
                label="Download Document Front"
                onClick={() => {
                  router.push(
                    `${props.kycData?.other_document_data?.front}&dl=${props.kycData?.other_document_data?.document_type}_front`,
                    undefined,
                    { shallow: true }
                  );
                }}
                buttonBaseClasses={{
                  font: "text-sm font-medium",
                  backgroundColor: "bg-blue-600 hover:bg-blue-700",
                  textColor: "text-white",
                  border: "any",
                  padding: "px-4 py-3",
                }}
              />
            </div>
            <ButtonBase
              variant="primary"
              type="button"
              label="Download Document Back"
              onClick={() => {
                router.push(
                  `${props.kycData?.other_document_data?.back}&dl=${props.kycData?.other_document_data?.document_type}_back`,
                  undefined,
                  { shallow: true }
                );
              }}
              buttonBaseClasses={{
                font: "text-sm font-medium",
                backgroundColor: "bg-blue-600 hover:bg-blue-700",
                textColor: "text-white",
                border: "any",
                padding: "px-4 py-3",
              }}
            />
          </div>
        )}
      </div>
      <div className="max-w-2xl sm:flex sm:justify-between space-y-4 sm:space-y-0 my-6">
        {props.kycData?.other_document_data?.front && (
          <div>
            <label className="block text-sm font-medium text-gray-800 mb-4">
              Front
            </label>
            <div className="h-48 w-72 sm:w-80 cursor-pointer">
              <img
                className="h-full w-full rounded-md object-cover"
                src={`${props.kycData?.other_document_data?.front}`}
              />
            </div>
          </div>
        )}
        {props.kycData?.other_document_data?.back && (
          <div>
            <label className="block text-sm font-medium text-gray-800 mb-4">
              Back
            </label>
            <div className="h-48 w-72 sm:w-80 cursor-pointer">
              <img
                className="h-full w-full rounded-md object-cover"
                src={`${props.kycData?.other_document_data?.back}`}
              />
            </div>
          </div>
        )}
      </div>
      <div className="flex items-center">
        <ShieldCheckIcon className="h-6 w-6 text-green-500 mr-2" />
        <label className="block text-sm font-bold text-gray-800 capitalize">
          {props.kycData?.other_document_data?.document_type} Verified
        </label>
      </div>
    </div>
  );
}
